export default __webpack_public_path__ + "static/media/IMG_2476.cebcaa07.jpg";